import React from 'react';
import { X } from 'lucide-react';

export const SCOPES = [
  { key: 'module', label: 'Moduler' },
  { key: 'issue', label: 'Ärenden' },
  { key: 'doc', label: 'Dokument' },
  { key: 'person', label: 'Personer' },
];

export function ScopeChips({ active, onChange }) {
  const toggle = (key) => {
    if (active === key) onChange(null);
    else onChange(key);
  };
  return (
    <div className="kp-scope-chips" role="group" aria-label="Sökfilter">
      {SCOPES.map((s) => (
        <button
          key={s.key}
          type="button"
          className={`kp-scope-chip${active === s.key ? ' kp-scope-chip--active' : ''}`}
          onClick={() => toggle(s.key)}
          aria-pressed={active === s.key}
        >
          {s.label}
        </button>
      ))}
      {active ? (
        <button
          type="button"
          className="kp-scope-chip-clear"
          onClick={() => onChange(null)}
          aria-label="Rensa filter"
        >
          <X size={11} strokeWidth={2.5} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
